/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Rationale_TitleInputs */

const en_us2_push_rationale_title = /** @type {(inputs: Push_Rationale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want notifications?`)
};

const pt_br2_push_rationale_title = /** @type {(inputs: Push_Rationale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer receber avisos?`)
};

const es_419_push_rationale_title = /** @type {(inputs: Push_Rationale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres recibir avisos?`)
};

const pt_pt2_push_rationale_title = /** @type {(inputs: Push_Rationale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queres receber notificações?`)
};

const fr_fr2_push_rationale_title = /** @type {(inputs: Push_Rationale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les notifications ?`)
};

const de_de2_push_rationale_title = /** @type {(inputs: Push_Rationale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen erhalten?`)
};

const it_it2_push_rationale_title = /** @type {(inputs: Push_Rationale_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi ricevere notifiche?`)
};

/**
* | output |
* | --- |
* | "Want notifications?" |
*
* @param {Push_Rationale_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_rationale_title = /** @type {((inputs?: Push_Rationale_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Rationale_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_rationale_title(inputs)
	if (locale === "es-419") return es_419_push_rationale_title(inputs)
	if (locale === "pt-PT") return pt_pt2_push_rationale_title(inputs)
	if (locale === "fr-FR") return fr_fr2_push_rationale_title(inputs)
	if (locale === "de-DE") return de_de2_push_rationale_title(inputs)
	if (locale === "it-IT") return it_it2_push_rationale_title(inputs)
	return en_us2_push_rationale_title(inputs)
});
export { push_rationale_title as "push.rationale_title" }